import * as Progress from 'react-native-progress'
export default Progress
